import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularcliStarRatingComponent } from './angularcli-star-rating.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AngularcliStarRatingComponent],
  exports : [AngularcliStarRatingComponent]
})
export class AngularcliStarRatingModule { }
